import { SelfServiceAPI } from 'types';
import { ContentHeading } from 'components/Typography';
import BottomTotal from 'components/BottomTotal';
import PaymentsCard from 'components/PaymentsCard';
import { Payments } from './utils';
import PaidLineItems from './components/PaidLineItems';

export interface PaymentSummaryProps {
  transactionAmounts: Payments;
  paidToDateAmounts?: Array<SelfServiceAPI.Total>;
}

const PaymentSummary = ({ transactionAmounts, paidToDateAmounts }: PaymentSummaryProps) => (
  <>
    <ContentHeading>Payment summary</ContentHeading>
    <PaymentsCard pb={paidToDateAmounts ? 0 : 1}>
      <PaidLineItems transactionAmounts={transactionAmounts} />
      {paidToDateAmounts && <BottomTotal title="Total paid to date" totals={paidToDateAmounts} />}
    </PaymentsCard>
  </>
);

export default PaymentSummary;
